class LL_DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.body = document.body;
    this.summary.addEventListener('click', this.toggleDetails.bind(this));
  }

  toggleDetails(event) {
    event.preventDefault(); // デフォルトの挙動を無効化

    if (this.details.hasAttribute('open')) {
      this.closeDetails();
    } else {
      this.openDetails();
    }
  }

  openDetails() {
    this.details.setAttribute('open', 'true');
    this.details.classList.add('is_open');
    this.body.setAttribute('dialog-open', 'true');

    const openingAnim = this.content.animate(this.openingAnimation(), this.animationSettings());
  }

  closeDetails() {
    this.details.classList.remove('is_open');
    this.body.setAttribute('dialog-open', 'false');

    const closingAnim = this.content.animate(this.closingAnimation(), this.animationSettings());
    closingAnim.onfinish = () => {
      this.details.removeAttribute('open');
    };
  }

  openingAnimation() {
    return [
      { transform: 'translateX(100%)', opacity: 0 },
      { transform: `translateX(0)`, opacity: 1 }
    ];
  }

  closingAnimation() {
    return [
      { transform: `translateX(0)`, opacity: 1 },
      { transform: 'translateX(100%)', opacity: 0 }
    ];
  }

  animationSettings() {
    return {
      duration: 300,
      easing: 'ease'
    };
  }
}

customElements.define('ll-details-disclosure', LL_DetailsDisclosure);
